import React from "react";
import { Heart, Handshake, Gift, UserPlus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BePartOfTheTransformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2024" id="donate-partner-cta" ref={ref} className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-linear-to-br from-accent via-accent/50 to-background opacity-90 z-0" />

      {}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <Heart className="text-primary/10 absolute -top-12 -left-12 h-64 w-64 -rotate-12 opacity-10 blur-sm" strokeWidth={1} />
        <Heart className="text-primary/10 absolute top-1/2 -right-24 h-96 w-96 rotate-12 opacity-10 blur-sm" strokeWidth={1} />
        <Heart className="text-primary/10 absolute -bottom-24 left-1/3 h-48 w-48 -rotate-6 opacity-5 blur-sm" strokeWidth={1} />
      </div>

      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className={`mx-auto max-w-3xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-serif text-4xl font-bold tracking-tight text-primary sm:text-5xl md:text-6xl mb-6">
            Help Us Share More Stories
          </h2>
          <p className="text-muted-foreground mx-auto mb-10 max-w-2xl text-lg md:text-xl">
            Support our mission to empower families and clinicians through the power of storytelling. Your contribution helps us amplify voices that need to be heard and build a supportive community.
          </p>

          <div className="mb-12">
            <h3 className="font-serif text-2xl font-bold text-primary mb-4">
              Your Gift of Hope
            </h3>
            <p className="text-muted-foreground mx-auto max-w-2xl mb-8">
              Every contribution directly impacts a child's journey. Your support can provide a therapy kit, workshop participation for families and caregivers, and other creative resources that foster healing and resilience.
            </p>
            <ul className="flex flex-wrap justify-center gap-3">
              {["$25", "$50", "$100", "$250", "$500"].map((amount, i) => <li key={amount} data-index={i} className="rounded-full border border-primary/20 bg-primary/5 px-6 py-2 text-sm font-semibold text-primary transition-all hover:bg-primary/10 hover:scale-105">
                  {amount}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            {}
            <Button asChild size="lg" variant="secondary" className="w-full min-w-[180px] sm:w-auto text-base font-medium shadow-lg hover:scale-105 transition-transform">
              <Link to="mailto:contact@healthstoriesmychild.org">
                <Handshake className="mr-2 h-5 w-5" />
                Collaborate With Us
              </Link>
            </Button>

            {}
            <Button asChild size="lg" className="w-full min-w-[180px] sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 text-base font-bold shadow-xl hover:scale-105 transition-transform">
              <Link to="#">
                <Gift className="mr-2 h-5 w-5" />
                Support Our Mission
              </Link>
            </Button>

            {}
            <Button asChild size="lg" variant="outline" className="w-full min-w-[180px] sm:w-auto border-primary/20 bg-transparent text-primary hover:bg-primary/5 hover:text-primary text-base font-medium shadow-lg hover:scale-105 transition-transform">
              <Link to="/ShareYourStoryPage">
                <UserPlus className="mr-2 h-5 w-5" />
                Share Your Story
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}